import { Alert, Backdrop, Button, CircularProgress, FormControl, Grid, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material";
import MenuFrame from "../frames/menu_frame";
import { useState } from "react";
import { newTicket } from "./ticket_halper";
import { isLogin } from "../authorization/auth";
import { validEmail, validPhoneNumber } from "../client/client_halper";
import "./service_request.css";

function ServiceRequest() {
    const [inputErrors, setInputErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [alertMessage, setAlertMessage] = useState(null);

    const __error_handler = (test, vr, msg) => {
        if (test) {
            inputErrors[vr] = "";
            setInputErrors({ ...inputErrors });
        } else {
            inputErrors[vr] = msg;
            setInputErrors({ ...inputErrors });
        }
        return !test;
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const priority = data.get("priority");
        const subject = data.get("subject");
        const message = data.get("message");
        const phone = data.get("phone");
        const email = data.get("email");

        var flag = true;
        if (__error_handler(message.length > 5, "message", "Please explain your issue.")) {
            flag = false;
        }
        if (__error_handler(subject.length > 3, "subject", "Please explain your issue.")) {
            flag = false;
        }
        if (__error_handler(validPhoneNumber(phone), "phone", "Please enter 10 digit phone number.")) {
            flag = false;
        }
        if (__error_handler((!email || validEmail(email)), "email", "Please enter email address for communication.")) {
            flag = false;
        }

        if (flag) {
            setIsLoading(true);
            newTicket(priority, subject, message, phone, email).then((res) => {
                event.target.reset();
                setAlertMessage({ severity: "success", message: res.message });
                setIsLoading(false);
            }).catch((err) => {
                setAlertMessage({ severity: "error", message: err.message });
                setIsLoading(false);
            });
        }
    }

    return (
        <MenuFrame login={false}>
            <Backdrop sx={(theme) => ({ color: 'text.primary', zIndex: theme.zIndex.drawer + 1 })} open={isLoading} >
                <CircularProgress color="inherit" />
            </Backdrop>
            {alertMessage === null ? "" :
                <Grid size={12} sx={{ mt: 2 }}>
                    <Alert severity={alertMessage.severity}>{alertMessage.message}</Alert>
                </Grid>
            }
            <Typography variant="h4" color="textPrimary" fontWeight={"bold"} className="menu-frame">Service Now</Typography>
            <Grid container size={{ xs: 12, sm: 10 }} component="form" onSubmit={handleSubmit} noValidate spacing={2} sx={{ mt: 2 }} className="grid-container">
                <Grid size={{ xs: 12, sm: 4 }} className="grid-item" sx={{ backgroundColor: "background.pallette" }}>
                    <FormControl fullWidth>
                        <InputLabel id="priority-label">Priority</InputLabel>
                        <Select
                            labelId="priority-label"
                            id="priority"
                            defaultValue={"low"}
                            label="Age"
                            name="priority"
                            variant="outlined"
                            error={!!inputErrors.priority} helperText={inputErrors.priority}
                        >
                            <MenuItem value={"low"}>Low</MenuItem>
                            <MenuItem value={"medium"}>Medium</MenuItem>
                            <MenuItem value={"high"}>High</MenuItem>
                            <MenuItem value={"critical"}>Critical</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                {isLogin() ? "" :
                    <>
                        <Grid size={{ xs: 12, sm: 4 }} className="grid-item">
                            <TextField variant="outlined" name="phone" fullWidth error={!!inputErrors.phone} helperText={inputErrors.phone} placeholder="Phone (Optional)" label="Phone" />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }} className="grid-item">
                            <TextField variant="outlined" name="email" fullWidth error={!!inputErrors.email} helperText={inputErrors.email} placeholder="Email (Optional)" label="Email" />
                        </Grid>
                    </>
                }
                <Grid size={{ xs: 12, sm: 12 }} className="grid-item" sx={{ backgroundColor: "background.pallette" }}>
                    <TextField variant="outlined" name="subject" fullWidth error={!!inputErrors.subject} helperText={inputErrors.subject} placeholder="Subject" label="Subject" />
                </Grid>
                <Grid size={{ xs: 12, sm: 12 }} className="grid-item" sx={{ backgroundColor: "background.pallette" }}>
                    <TextField variant="outlined" name="message" fullWidth multiline rows={4} error={!!inputErrors.message} helperText={inputErrors.message} placeholder="Message" label="Message" />
                </Grid>
                <Grid size={{ xs: 12, sm: 12 }} className="grid-item" sx={{ backgroundColor: "background.pallette" }}>
                    <Button variant="contained" color="primary" fullWidth type="submit">Submit</Button>
                </Grid>
            </Grid>
        </MenuFrame>
    );
}

export default ServiceRequest;